import React from 'react';
import DesignersPage from '../designers/DesignersPage';

/** Luxury browse — designer listings plus pre-owned luxury marketplace pieces. */
const LuxuryPage = () => <DesignersPage brandKey="luxury" />;

export default LuxuryPage;
